import { Menu } from "../../constants/Constants";
import { Paths } from "../../constants/UrlConstants";

const homeMenuItem = {
  id: "home",
  menuName: Menu.Home,
  pathTo: Paths.HomeRoot,
  label: "Home"
};
const coverMenuItem = {
  id: "cover",
  menuName: Menu.Cover,
  pathTo: Paths.Cover,
  label: "Cover"
};
const claimsMenuItem = {
  id: "claims",
  menuName: Menu.Claims,
  pathTo: Paths.Claims,
  label: "Claims"
};

const healthSupportMenuItem = {
  id: "health-support",
  menuName: Menu.HealthSupport,
  pathTo: Paths.HealthSupport,
  label: "Health support"
};

const healthSupportMenuItemForHol = {
  id: "health-support",
  menuName: Menu.HealthSupport,
  pathTo: Paths.HealthHub,
  label: "Health hub"
};

if(!window?.axa?.features?.healthUnlockedFeature) {
  healthSupportMenuItemForHol.pathTo = Paths.HealthHub;
}

const healthStoreMenuItem = {
  id: "health-store",
  menuName: Menu.HealthStore,
  pathTo: Paths.HealthStore,
  label: "Member offers"
};

const healthStoreMenuItemForHol = {
  id: "health-store",
  menuName: Menu.HealthStore,
  pathTo: Paths.HealthStore,
  label: "Customer offers"
};

const contactMenuItem = {
  id: "contact",
  menuName: Menu.ContactUs,
  pathTo: Paths.ContactUs,
  label: "Contact Us"
};

const commonMenu = [
  homeMenuItem,
  coverMenuItem,
  healthSupportMenuItem,
  healthStoreMenuItem,
  contactMenuItem
];

const commonMenuWithClaims = [
  homeMenuItem,
  coverMenuItem,
  claimsMenuItem,
  healthSupportMenuItem,
  healthStoreMenuItem,
  contactMenuItem
];

const holMenu = [
  homeMenuItem,
  coverMenuItem,
  healthSupportMenuItemForHol,
  healthStoreMenuItemForHol,
  contactMenuItem
];

const holMenuWithClaims = [
  homeMenuItem,
  coverMenuItem,
  claimsMenuItem,
  healthSupportMenuItemForHol,
  healthStoreMenuItemForHol,
  contactMenuItem
];

const HeaderMenu = {
  Any: { Any: commonMenu, Claims: commonMenuWithClaims },
  HOL: { Any: holMenu, Claims: holMenuWithClaims }
};

export default HeaderMenu;
